export default __webpack_public_path__ + "static/media/windows-crop.37946e02.jpg";